import React, { useEffect } from 'react'
import { useParams } from 'react-router';
import { useToaster } from '_common/hooks/actions/common/appToasterHook';
import { useEventApi } from '_common/hooks/actions/event/appEventApiHook';
import { APPLICATION_GLOBAL_SLUG, CRYPTO_SECRET_KEY } from '_config';
import Cryptr from 'cryptr';

const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

function GeoLocation() {

  const urlParams = useParams<any>()
  const eventApi = useEventApi()
  const toast = useToaster()

  const getRodeoEventGeoLocations = () => {
    const params:any = {
      game_slug: APPLICATION_GLOBAL_SLUG,
      rodeo_event_id: cryptr.decrypt(urlParams.rodeoEventId),
    };
    // const guest_user_id = localStorage.getItem(GUEST_USER_ID);
    // if (guest_user_id && !userDetails) {
    //   params["guest_user_id"] = guest_user_id;
    // }

    eventApi.callGetRodeoEventGeoLocations(
      params,
      (_message: string, resp: any) => {
        // console.log({resp})
        // setGeoLocationList(resp)
        if (navigator.geolocation) {
          // timeout at 100000 milliseconds (10 seconds)
          const options = { timeout: 100000, enableHighAccuracy: false, maximumAge: 0 };
          const geoLoc = navigator.geolocation;
          geoLoc.watchPosition(e=>loadLocation(e, resp), errorLoadLocation, options);
          // console.log({watchID})

        } else {
          console.log("Sorry, browser does not support geolocation!");
        }
      },
      (message: string) => {
        toast.error(message)
      }
    )
  }

  const isInPolygon = (points_polygon: any, vertices_x: any, vertices_y: any, latitude: any, longitude: any) => {
    let i = 0
    let j = 0
    let c = false
    console.log({points_polygon,vertices_x,vertices_y, latitude, longitude})
    for (i = 0, j = points_polygon - 1; i < points_polygon; j = i++) {
      
      if (((Number(vertices_y[i]) > longitude) != (Number(vertices_y[j]) > longitude)) && (latitude < (Number(vertices_x[j]) - Number(vertices_x[i])) * (longitude - Number(vertices_y[i])) / (Number(vertices_y[j]) - Number(vertices_y[i])) + Number(vertices_x[i]))) {
        c = !c;
      }
    }
    return c
  }

  const loadLocation = (position: any, geoList: any) => {
    // const { dispatch, geoLocationList, currentLocation } = this.props;
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    localStorage.setItem('latitude', String(latitude))
    localStorage.setItem('longitude', String(longitude))
    let geoId = 0
    let cnt = false
    // console.log({geoList})
    if (geoList) {
      geoList.forEach((x:any) => {
        if (!cnt) {

          const points_polygon = x.vertices_x.length;
          const cur_loc = isInPolygon(points_polygon, x.vertices_x, x.vertices_y, latitude, longitude)
          //  const polygon = JSON.parse(x.data)
          //  let cur_loc2 = insidePolygon([latitude, longitude], polygon)

          // let polygon = x.vertices_x?.map((xv:any, i: any)=>
          //   [xv,x.vertices_y[i]]
          // )          
          // let cur_loc = pointInPolygon(polygon, [latitude,longitude])

          console.log({latitude, longitude, cur_loc})
          
          if (cur_loc) {
            geoId = x.id
            cnt = true
          }
        }
      })

      let chkCnt = Number(localStorage.getItem('outCount'))
      const currentLocation = Number(localStorage.getItem('geolocation_val'))
      // console.log({currentLocation, chkCnt})
      // if ((!currentLocation && geoId) || (currentLocation && geoId && currentLocation.geoId != geoId)) {
      if ((!currentLocation && geoId) || (currentLocation && geoId && currentLocation != geoId)) {
          // eventAction.currentLoc({
          //   latitude: latitude,
          //   longitude: longitude,
          //   insidestate: true,
          //   geo_id: geoId
          // })
          localStorage.setItem('geolocation_val', geoId+"");
      }
      if (geoId == 0) {
        chkCnt++
        localStorage.setItem('outCount', chkCnt+"")
        if(chkCnt > 5) {
          localStorage.removeItem('geolocation_val')
          localStorage.removeItem('outCount')
        }
      }
      // if (localStorage.getItem('geolocation_val') && geoId == 0 && chkCnt > 5) {
      //   localStorage.removeItem('geolocation_val')
      //   localStorage.removeItem('outCount')
        // chkCnt = 0
        // eventAction.clearCurrentLoc()
      // }
    }
    else {
      if (localStorage.getItem('geolocation_val')) {
        localStorage.removeItem('geolocation_val')
        // eventAction.clearCurrentLoc()
      }
    }
  }

  const errorLoadLocation = (err: any) => {
    if (err.code == 1) {
      console.log("Error: Access is denied!");
    } else if (err.code == 2) {
      console.log("Error: Position is unavailable!");
    }
  }

  useEffect(()=>{
    localStorage.setItem('outCount', "0")
    getRodeoEventGeoLocations()
  },[])

  // useEffect(()=>{
  //   if(geoLocationList && navigator.geolocation) {
  //       console.log({geoLocationList})
  //       // timeout at 100000 milliseconds (10 seconds)
  //       let options = { timeout: 100000, enableHighAccuracy: false, maximumAge: 0 };
  //       let geoLoc = navigator.geolocation;
  //       let watchID = geoLoc.watchPosition(e=>loadLocation(e, geoLocationList), errorLoadLocation, options);

  //   } else {
  //     console.log("Sorry, browser does not support geolocation!");
  //   }
  // },[geoLocationList, navigator])

  return (
    <React.Fragment>
      {/* <h2 style={{color: "white"}}>{message}</h2> */}
    </React.Fragment>
  )
}

export default GeoLocation
